export enum RegisteredMessage {
    AccountSuspended = 'account_suspended',
    ApprovedToBid = 'approved_to_bid',
    RegistrationPending = 'registration_pending',
    RequestSubmitted = 'request_submitted',
}
